import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/SecretShop.css';

// Importar imágenes
import Amaterasu from '../assets/easteregg/Amaterasu.webp';
import Draugur from '../assets/easteregg/Draugur.webp';
import Kanashii from '../assets/easteregg/Kanashii.webp';
import Tetra from '../assets/easteregg/Tetra.webp';
import Golgotha from '../assets/easteregg/Golgotha.webp';
import DShadow from '../assets/easteregg/dShadow.webp';
import Medievo from '../assets/easteregg/Medievo.webp';
import Coro from '../assets/easteregg/Coro.webp';
import Bremen from '../assets/easteregg/Bremen.webp';
import Bremen2 from '../assets/easteregg/Bremen2.webp';
import Chrisandme from '../assets/easteregg/Chrisandme.webp';
import Chemita from '../assets/easteregg/Chemita.webp';
import Tecia from '../assets/easteregg/Tecia.webp';
import Xtremebcn from '../assets/easteregg/Xtremebcn.webp';
import Kraushen from '../assets/easteregg/Kraushen.webp';
import Kraushenwinner from '../assets/easteregg/Kraushenwinner.webp';
import DShadowWinner from '../assets/easteregg/dShadowwinner.webp';

const SecretShop = () => {
    const { t } = useTranslation();
    const [showLegatusModal, setShowLegatusModal] = useState(false);
    const [showChairmanModal, setShowChairmanModal] = useState(false);
    const [showFiestaModal, setShowFiestaModal] = useState(false);
    const [showSoldOutModal, setShowSoldOutModal] = useState(false);
    const [soldOutMessage, setSoldOutMessage] = useState('');
    const [clickCount, setClickCount] = useState(0);

    const products = [
        {
            id: 1,
            name: 'Amaterasu',
            subtitle: 'CORVUS NOCTA',
            image: Amaterasu,
            price: '99,99€',
            type: 'POP!',
            isNew: true
        },
        {
            id: 2,
            name: 'Draugur',
            subtitle: 'CORVUS NOCTA',
            image: Draugur,
            price: '99,99€',
            type: 'POP!',
            isNew: true
        },
        {
            id: 3,
            name: 'Kanashii',
            subtitle: 'CORVUS NOCTA',
            image: Kanashii,
            price: '99,99€',
            type: 'POP!',
            isNew: true
        },
        {
            id: 4,
            name: 'Tetra',
            subtitle: 'CORVUS NOCTA',
            image: Tetra,
            price: '99,99€',
            type: 'POP!',
            isNew: true
        },
        {
            id: 5,
            name: 'Golgotha',
            subtitle: 'CORVUS NOCTA',
            image: Golgotha,
            price: '99,99€',
            type: 'POP!',
            isNew: true
        },
        {
            id: 6,
            name: 'dShadow',
            subtitle: 'CORVUS NOCTA',
            image: DShadow,
            price: '99,99€',
            type: 'POP!',
            isNew: true
        },
        {
            id: 7,
            name: 'Medievo',
            subtitle: 'CORVUS NOCTA',
            image: Medievo,
            price: '99,99€',
            type: 'POP!',
            isNew: true
        },
        {
            id: 8,
            name: 'Coro',
            subtitle: 'CORVUS NOCTA',
            image: Coro,
            price: '99,99€',
            type: 'POP!',
            isNew: true
        },
        {
            id: 9,
            name: 'Chemita',
            subtitle: 'CORVUS NOCTA',
            image: Chemita,
            price: '99,99€',
            type: 'POP!',
            isNew: true
        },
        {
            id: 10,
            name: 'Xtremebcn',
            subtitle: 'CORVUS NOCTA',
            image: Xtremebcn,
            price: '99,99€',
            type: 'POP!',
            isNew: true
        },
        {
            id: 11,
            name: 'Kraushen',
            subtitle: 'CORVUS NOCTA',
            image: Kraushen,
            price: '99,99€',
            type: 'POP!',
            isNew: true
        }
    ];

    const handleLegatusClick = () => {
        setShowLegatusModal(true);
        setTimeout(() => setShowLegatusModal(false), 3000);
    };

    const handleChairmanClick = () => {
        setShowChairmanModal(true);
        setTimeout(() => setShowChairmanModal(false), 3000);
    };

    const handleFiestaClick = () => {
        setShowFiestaModal(true);
        setTimeout(() => setShowFiestaModal(false), 3000);
    };

    const handleAddToCartClick = () => {
        const newCount = clickCount + 1;
        setClickCount(newCount);
        
        let message = '';
        
        if (newCount === 3) {
            message = "Really, they're all sold out...";
        } else if (newCount === 6) {
            message = "Man, they still sold out... why you insist?";
        } else if (newCount === 10) {
            message = "Seriously, you need to touch grass man";
        }
        
        if (message) {
            setSoldOutMessage(message);
            setShowSoldOutModal(true);
            setTimeout(() => setShowSoldOutModal(false), 3000);
        }
    };

    return (
        <div className="secret-shop">
            {showLegatusModal && (
                <div className="modal">
                    <div className="modal-content">
                        <p>You are not a Legatus yet</p>
                    </div>
                </div>
            )}
            
            {showChairmanModal && (
                <div className="modal">
                    <div className="modal-content">
                        <p>Only for Chris and his friend Kanashii</p>
                    </div>
                </div>
            )}

            {showFiestaModal && (
                <div className="modal">
                    <div className="modal-content">
                        <p>Tío, dónde está mi coche?!</p>
                    </div>
                </div>
            )}

            {showSoldOutModal && (
                <div className="modal">
                    <div className="modal-content">
                        <p>{soldOutMessage}</p>
                    </div>
                </div>
            )}

            <div className="banner-container">
                <div className="banner banner-left">
                    <h2>EXCLUSIVES</h2>
                    <img src={Chrisandme} alt="Chris and me" className="banner-image-left" />
                    <p>CHAIRMAN'S<br />LODGE</p>
                    <button className="banner-button" onClick={handleChairmanClick}>SHOP COLLECTION</button>
                </div>
                <div className="banner banner-right">
                    <h2>ULTIMATES</h2>
                    <p>LEGATUS<br />COLLECTION</p>
                    <button className="banner-button" onClick={handleLegatusClick}>SHOP COLLECTION</button>
                    <img src={Bremen} alt="Bremen" className="banner-image" />
                    <img src={Bremen2} alt="Bremen 2" className="banner-image-second" />
                    <span className="banner-text">BREMEN</span>
                </div>
            </div>

            <div className="secret-shop-header">
                <h1>Corvus Nocta - Colección Exclusiva</h1>
                <p>¡Has descubierto nuestra colección secreta de Funko Pop!</p>
            </div>
            
            <div className="products-grid">
                {products.filter(product => product.id !== 10).map(product => (
                    <div key={product.id} className="product-card">
                        <div className="product-image">
                            {product.isNew && <span className="new-badge">NEW</span>}
                            <img src={product.image} alt={product.name} />
                        </div>
                        <div className="product-info">
                            <div className="product-type">{product.type}</div>
                            <h3>{product.name} - {product.subtitle}</h3>
                            <div className="product-price">{product.price}</div>
                            <div className="product-button">
                                <span className="sold-out">SOLD OUT</span>
                                <button onClick={handleAddToCartClick}>ADD TO CART</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="banner-container banner-fiesta-container">
                <div className="banner banner-fiesta">
                    <div className="banner-content">
                        <div className="title-group">
                            <h2>FIESTA</h2>
                            <p>COLLECTION</p>
                        </div>
                        <button className="banner-button" onClick={handleFiestaClick}>SHOP COLLECTION</button>
                    </div>
                    <div className="banner-winners">
                        <div className="winner-item">
                            <span className="first-position-badge">
                                <span className="copper-text">XTREMEBCN</span><br />
                                Easter Egg Winner
                            </span>
                            <img src={Xtremebcn} alt="Xtremebcn" className="winner-image" />
                        </div>
                        <div className="winner-item">
                            <span className="first-position-badge">
                                <span className="copper-text">KRAUSHEN</span><br />
                                2nd Position
                            </span>
                            <img src={Kraushenwinner} alt="Kraushenwinner" className="winner-image" />
                        </div>
                        <div className="winner-item">
                            <span className="first-position-badge">
                                <span className="copper-text">DSHADOW</span><br />
                                3rd Position
                            </span>
                            <img src={DShadowWinner} alt="DShadow Winner" className="winner-image" />
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="final-banner">
                <div className="tessa-decoration">
                    <img src={Tecia} alt="Tecia" />
                </div>
                <div className="banner-content">
                    <h2>EXCLUSIVE COLLECTION</h2>
                    <p>CORVUS NOCTA</p>
                </div>
            </div>
        </div>
    );
};

export default SecretShop; 